import { t } from 'i18next';
import type { I18nPrefix } from '../../../i18n/prefix';

const LOCALE = 'features:storefront_options.components.locale_editor' satisfies I18nPrefix;

export function localeError(
  locale: string,
  isDuplicate: boolean,
  showErrors: boolean,
): string | undefined {
  if (isDuplicate) return t(`${LOCALE}.locale_duplicate`);
  if (showErrors && locale.trim() === '') return t(`${LOCALE}.locale_required`);
  return undefined;
}

export function entryKeyError(
  key: string,
  isDuplicate: boolean,
  showErrors: boolean,
): string | undefined {
  if (isDuplicate) return t(`${LOCALE}.key_duplicate`);
  if (showErrors && key.trim() === '') return t(`${LOCALE}.key_required`);
  return undefined;
}
